import React from "react";
import type { AppStatus } from "../../utils/types";

interface Props {
  status: AppStatus | string;
}

const getClasses = (status: string): string => {
  switch (status) {
    case "deployed":
      return "bg-green-100 text-green-700 border border-green-400";
    case "live":
      return "bg-violet-100 text-violet-700 border border-violet-400";
    case "deploying":
      return "bg-blue-100 text-blue-700 border border-blue-400";
    case "draft":
      return "bg-gray-100 text-gray-600 border border-gray-300";
    case "submitted":
      return "bg-amber-100 text-amber-700 border border-amber-400";
    case "failed":
      return "bg-red-100 text-red-700 border border-red-400";
    default:
      return "bg-gray-100 text-gray-600";
  }
};

const AppStatusBadge: React.FC<Props> = ({ status }) => (
  <span
    className={`inline-block px-3 py-1 rounded-full text-xs font-medium capitalize whitespace-nowrap ${getClasses(
      status
    )}`}
    title={status}
  >
    {status}
  </span>
);

export default AppStatusBadge;
